/**
 * Tracks which draft RFQ ids arrived over the live DRFQ WebSocket
 * (a `DRAFT_ADDED` event) in the current page-load.
 *
 * The RFQ-builder opener uses this instead of a `created_at` freshness
 * window: `created_at` is server time compared against the client clock,
 * so skew makes a wall-clock window unreliable (a slow client treats
 * every draft as fresh, defeating the reload-rehydrate guard). Arrival is
 * skew-free and answers the real question — "did this draft come over the
 * live socket this session, or from the REST rehydrate of the Drafts
 * tab?". The set is module-scoped and intentionally resets on reload, so
 * a draft rehydrated from REST after a reload is never treated as a fresh
 * arrival.
 */

const wsDeliveredDraftIds = new Set<string>();

/** Record a draft id as delivered over the live WS this session. */
export function markDraftWsDelivered(id: string | number): void {
  wsDeliveredDraftIds.add(String(id));
}

/** True if this draft id arrived over the live WS this session. */
export function wasDraftWsDelivered(id: string | number): boolean {
  return wsDeliveredDraftIds.has(String(id));
}

/** Test seam. */
export function resetDraftWsArrivals(): void {
  wsDeliveredDraftIds.clear();
}
